import { millisecondsInWeek as r } from "./constants.js";
import { startOfISOWeek as f } from "./startOfISOWeek.js";
import { startOfISOWeekYear as m } from "./startOfISOWeekYear.js";
import { toDate as a } from "./toDate.js";
function p(e) {
  const t = a(e), o = +f(t) - +m(t);
  return Math.round(o / r) + 1;
}
export {
  p as default,
  p as getISOWeek
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/getISOWeek.js
// module id = 883
// module chunks = 67